module.exports = __webpack_public_path__ + "img/credit-card-fill.68baaf41.svg";